"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldPaginationCoreInputs = void 0;
class EmeraldPaginationCoreInputs {
    constructor() {
        this.total = 0;
        this.totalRecords = 0;
        this.pageSizeOptions = [10, 25, 100];
        this.currentPage = 1;
        this.pageRangeDisplayed = 5;
        this.pageSizeLabel = 'Per Page';
        this.pagesLabel = 'Pages';
        this.showNumberedList = false;
        this.showNumberMenu = true;
        this.showRecords = true;
        this.ofLabel = 'of';
        this.itemsLabel = 'Records';
    }
}
exports.EmeraldPaginationCoreInputs = EmeraldPaginationCoreInputs;
//# sourceMappingURL=pagination.inputs.js.map